import { setMultiAddAnchor } from '../../../../state/internal/actions';
import { defineTransaction } from '../../../common/transactions';
import { SET_MULTI_ADD_ANCHOR, type SetMultiAddAnchorAction } from './action';

export default defineTransaction(SET_MULTI_ADD_ANCHOR, (action: SetMultiAddAnchorAction) =>
	setMultiAddAnchor(action.payload),
);
